var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.settings
    ? _c(
        "div",
        { staticStyle: { "text-align": "left" } },
        [
          _vm._v("\n\tSearch in: "),
          _c("SelectPicker", {
            attrs: { options: _vm.settings.searchable_elements, hideEmpty: "" },
            model: {
              value: _vm.element_searched,
              callback: function ($$v) {
                _vm.element_searched = $$v
              },
              expression: "element_searched",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "boxes", staticStyle: { "text-align": "center" } },
            _vm._l(_vm.query_from_store, function (v, id) {
              return _c("ConceptSearchBox", {
                key: id,
                staticStyle: { "min-width": "250px" },
                attrs: { id: "b" + id, settings: _vm.settings, value: v },
                on: {
                  input: function ($event) {
                    return _vm.updateSubquery(id, $event)
                  },
                },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-default",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.resetQuery.apply(null, arguments)
                },
              },
            },
            [_vm._v("Reset")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-default",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.addBox.apply(null, arguments)
                },
              },
            },
            [_vm._v("Add box")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-default",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.removeBox.apply(null, arguments)
                },
              },
            },
            [_vm._v("Remove box")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-sm btn-default",
              attrs: {
                role: "button",
                target: "_blank",
                href:
                  _vm.settings.lexit_server +
                  "?db=" +
                  _vm.settings.lexit_instance +
                  "&table=lexicon",
              },
            },
            [_vm._v("View lexicon")]
          ),
          _vm._v(" "),
          _c("label", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.showQuery,
                  expression: "showQuery",
                },
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.showQuery)
                  ? _vm._i(_vm.showQuery, null) > -1
                  : _vm.showQuery,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.showQuery,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.showQuery = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.showQuery = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.showQuery = $$c
                  }
                },
              },
            }),
            _vm._v(" Show query"),
          ]),
          _vm._v(" "),
          _vm.showQuery
            ? _c(
                "div",
                {
                  staticStyle: {
                    border: "1px solid black",
                    "margin-top": "1em",
                    padding: "4pt",
                  },
                },
                [
                  _vm._v("\n\t\tSettings:\n\t\t"),
                  _c("pre", {
                    domProps: { textContent: _vm._s(_vm.settings) },
                  }),
                  _vm._v(" "),
                  _c("i", [_vm._v("Query")]),
                  _vm._v(" "),
                  _vm._l(_vm.query_from_store, function (subquery, i) {
                    return _c(
                      "div",
                      { key: i, staticStyle: { "margin-bottom": "1em" } },
                      [
                        _c("b", [_vm._v("b" + _vm._s(i))]),
                        _vm._v(
                          " → [" +
                            _vm._s(
                              subquery
                                .map(function (t) {
                                  return t.value
                                })
                                .join("; ")
                            ) +
                            "]\n\t\t"
                        ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("i", [_vm._v("CQL rendition")]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "code",
                    domProps: { textContent: _vm._s(_vm.query_cql_from_store) },
                  }),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }